import Colors from '@dynatrace/strato-design-tokens/colors';

//region Default Values
export const DEFAULT_MIN_RANGE_VALUE = 0;
export const DEFAULT_MAX_RANGE_VALUE = 100;
export const DEFAULT_CHART_WIDTH = '100%';
export const DEFAULT_CHART_HEIGHT = 300;
//endregion

//region Sizes
export const MIN_SIZE_IN_PX = 100;
export const MIN_MAX_PADDING = 20;
export const MIN_MAX_LABEL_RESERVED_HEIGHT_IN_PX = 16;
export const ARC_OUTER_RADIUS_PERCENTAGE = 0.9;
export const ARC_INNER_RADIUS_PERCENTAGE = 0.8;
export const GAUGE_VERTICAL_SMALL_OFFSET = 0.05;
export const GAUGE_VERTICAL_DEFAULT_OFFSET = 0.1;
//endregion

// region Colors
export const ARC_BACKGROUND_COLOR = Colors.Theme.Neutral['40'];
export const ARC_DEFAULT_VALUE_COLOR =
  Colors.Charts.Categorical.Color11.Default;
export const THRESHOLD_COLOR_DEFAULT =
  Colors.Charts.Categorical.Color11.Default;
//endregion

// region Arc Properties
export const ARC_START_ANGLE = -0.625 * Math.PI; // −112.5º in radians
export const ARC_END_ANGLE = 0.625 * Math.PI; // 112.5º in radians
//endregion

//region Threshold Interval Arcs
export const THRESHOLD_INTERVAL_MIN_OFFSET = 4;
export const THRESHOLD_INTERVAL_MAX_OFFSET = 8;
export const THRESHOLD_INTERVAL_MIN_GAP = 1;
export const THRESHOLD_INTERVAL_MAX_GAP = 8;
export const THRESHOLD_INTERVAL_MIN_THICKNESS = 2;
export const THRESHOLD_INTERVAL_MAX_THICKNESS = 8;
export const THRESHOLD_INTERVAL_MIN_LENGTH_PX = 1;
export const THRESHOLD_INTERVAL_SCALE_MIN_ARC_WIDTH = 10;
export const THRESHOLD_INTERVAL_SCALE_MAX_ARC_WIDTH = 20;
export const SHOW_THRESHOLD_INDICATORS_DEFAULT = true;
//endregion

//region Config Defaults
export const GAUGE_DEFAULT_CONFIG = {
  color: ARC_DEFAULT_VALUE_COLOR,
  min: DEFAULT_MIN_RANGE_VALUE,
  max: DEFAULT_MAX_RANGE_VALUE,
  formatter: undefined,
  loading: false,
  showThresholdIndicators: SHOW_THRESHOLD_INDICATORS_DEFAULT,
  tooltip: {},
};
//endregion

export const DISPLAY_NAME = 'GaugeChart';

export const GAUGE_CHART_ARIA_LABEL = 'Gauge Chart';

export const FONT_HEIGHT_RATIO = 0.7;
export const DEFAULT_MAX_VALUE_FONT_SIZE = 240;

export const zIndexGaugeAreas = {
  toolbar: 2,
  tooltip: 1,
  overlay: 0,
};
